/**
 * Ícone de arquivo PDF.
 *
 * Existe separado do PrintIcon porque exportar e imprimir são ações diferentes para quem
 * lê o botão: a impressora sugere papel, e o que o portal entrega é um arquivo que o
 * barbeiro guarda ou manda no WhatsApp.
 */
const PdfIcon = (props) => {
    const { className } = props;
    return (<i className={"fa-solid fa-file-pdf " + className}></i>)
}

export default PdfIcon;
